import { all, call, put, takeLatest } from 'redux-saga/effects';

import { actions } from 'react/api/actions/localzIntegrationLogs';
import defaultFetch from 'react/api/sagas/fetch/defaultFetch';

const {
  clearLogs,
  fetchLogs,
  setIsLoadingLogs,
  updateLogs
} = actions;


export function showLoading() {
  App.Forms.LocalzIntegrationLog?.filterBuilder?.loading?.init();
  App.Forms.LocalzIntegrationLog?.filterBuilder?.loading?.show();
}

export function hideLoading() {
  App.Forms.LocalzIntegrationLog?.filterBuilder?.loading?.hide();
}

export function* fetchLogsSaga(action) {
  const { filtersPayload, tenant } = action.payload;

  const encodedURL = encodeURI('/ActionsLogs');
  const requestBody = Object.assign({
    page: 0,
    pageSize: 51,
  }, filtersPayload);

  yield all([
    put({
      type: setIsLoadingLogs,
      payload: {
        isLoading: true
      }
    }),
    call(showLoading)
  ]);

  const options = {
    headers: {
      Accept: 'application/json;;charset=utf-8',
      'Content-Type': 'application/json;charset=utf-8',
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      'X-Tenant': tenant,
    },
  };

  const localzIntegrationLogs = yield call(defaultFetch, encodedURL, requestBody, 'POST', true, options);

  if (!localzIntegrationLogs?.error) {
    const { list } = localzIntegrationLogs;
    const shouldClearData = requestBody.page === 0 && !list.length;
    const shouldClearBeforeUpdateLogs = requestBody.page === 0 && list.length > 0;

    if (shouldClearData) {
      yield put({
        type: clearLogs
      });
    } else {
      yield put({
        type: updateLogs,
        payload: {
          data: list.map(item => {
            return {
              routeKey: item.routeKey,
              stopKey: item.stopKey,
              requestDate: item.requestDate,
              routeDate: item.routeDate,
              organizationKey: item.organizationKey,
              status: item.status,
              message: item.message,
              actionPerformed: item.actionPerformed,
              'organization.organization': item.organizationKey
            }
          }),
          shouldClearBeforeUpdateLogs,
        },
      });
    }
  }

  yield all([
    put({
      type: setIsLoadingLogs,
      payload: {
        isLoading: false
      }
    }),
    call(hideLoading)
  ]);
}

export function* watchFetchLogs() {
  yield takeLatest(fetchLogs, fetchLogsSaga);
}

export default function* () {
  yield all([
    watchFetchLogs(),
  ]);
}
